module.exports = __webpack_public_path__ + "static/media/personal-values@2x.5cdf5713.png";